import React, { useEffect, useState, useRef } from "react";
import dynamic from "next/dynamic";
import { loginEventBus } from "@/utils/useCrypRequest";
import { eventBus, LOGIN_SUCCESS_EVENT } from "@/utils/eventBus";
import LoginModal from "./login";

const LoginSuc = dynamic(() => import("@/components/login/ui/LoginSuc"), {
  ssr: false,
});

export const LoginProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [show, setShow] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loginUserInfo, setLoginUserInfo] = useState<{
    userId?: string;
    userInfoBaseResp?: {
      id: number;
      nickName: string;
      email: string;
      headImgUrl: string;
    };
  } | null>(null);
  const timeRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    const unsubscribe = loginEventBus.subscribe(() => {
      setShow(true);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const handleLoginSuccess = (userInfo: any) => {
      setLoginUserInfo({
        userId: userInfo.userId,
        userInfoBaseResp: userInfo.userInfoBaseResp,
      });
      setShowSuccessModal(true);
      // 30秒后自动关闭成功弹窗
      timeRef.current = setTimeout(() => {
        setShowSuccessModal(false);
      }, 30000);
    };

    eventBus.on(LOGIN_SUCCESS_EVENT, handleLoginSuccess);

    return () => {
      eventBus.off(LOGIN_SUCCESS_EVENT, handleLoginSuccess);
      if (timeRef.current) {
        clearTimeout(timeRef.current);
        timeRef.current = null;
      }
    };
  }, []);

  return (
    <>
      {children}
      <LoginModal show={show} onClose={() => setShow(false)} />
      {/* 登录成功弹窗 */}
      {showSuccessModal && (
        <LoginSuc
          loginUserInfo={loginUserInfo}
          onClose={() => setShowSuccessModal(false)}
        />
      )}
    </>
  );
};
